/*  ==============================================
//  Created by tuanBa                          ||
//  create at: 2022-03-15                      ||
//===============================================*/
import { Component, EventEmitter, Injectable, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { EvsStoreService } from '../../../../../common/services/EvsStore.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../../common/services/Category.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { StoreSaleService } from './services/store-sale.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
declare var $: any;
var that: any;

@Component({
  moduleId: module.id,
  selector: 'app-store-sale-edit',
  templateUrl: './store-sale_edit.component.html',
  styleUrls: ['../store.css'],
  providers: [ConfirmationService, EvsStoreService, EvsAddressService]
})

@Injectable()
export class StoreSaleEditComponent implements OnInit, OnDestroy {
  @Input('itemId') itemId: any;
  @Output('backUpdate') backUpdate = new EventEmitter();

  private langSub: Subscription;

  public store: any = {};
  public message: { class: string, content: string } = null;
  public error: string = '';
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public componentData = null;
  public routerChange: any;
  public selectedStore: Array<string>;
  public id_store: number = 0;
  public currentNumberImage: any = 0;
  public listIndexImage: any = [];
  public img: any = [];

  title: string = 'My first AGM project';
  lat: number = 51.678418;
  lng: number = 7.809007;
  // tslint:disable-next-line:member-ordering
  public images: any = [];

  constructor(private injector: Injector,
    private _location: Location,
    private storeService: EvsStoreService,
    public addressService: EvsAddressService,
    private upload: UploadService,
    private activatedRoute: ActivatedRoute,
    private cate: CategoryService,
    private _fb: FormBuilder,
    private storeSaleService: StoreSaleService,
    private toastr: ToastrService,
    private translate: TranslateService) {
    that = this;
  }

  ngOnInit() {
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });

    this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
      //this.id_store = params['id'];
      this.id_store = this.itemId;
      this.getDetail(this.itemId);
    });
  }

  backFromUpdate() {
    that.backUpdate.emit({
      isBack: true
    })
    //this._location.back();
  }

  initSelect2() {
    let _province = $('#_province');
    let _district = $('#_district');

    _province.select2({ placeholder: '-- ' + this.translate.instant('TINH_THANH_PHO') + ' --', allowClear: false, width: '100%' });
    _district.select2({ placeholder: '-- ' + this.translate.instant('QUAN_HUYEN_LABEL') + ' --', allowClear: false, width: '100%' });

    _province.off('select2:select').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      var id = e.target.value;
      that.loadDistrictData(id);
    });

    _district.off('select2:select').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
        if (c.id == this.store.provinceId) {
          this.loadDistrictData(c.id);
        }
      });
      this.cities = citiesList;
    });
  }

  getDetail(id) {
    this.storeSaleService.detailStoreSale(id).toPromise().then(res => {
      if (res) {
        if (!res.error) {
          this.store = res.data;
          if (res.data.image) {
            this.img.push(res.data.image)
            this.appendImageToShow(res.data.image)
          }
          console.log('detail', this.store);
          console.log('district', this.store.districtId);
          console.log('district', this.img);
          // this.selectedStore = [this.store.type];
          this.getCity();
          // $('#_type').val(this.store.type).trigger('change');//set selected type
          $('#_province').val(this.store.province).trigger('change')
          $('#_district').val(this.store.district).trigger('change')
        } else {
          this.message = { class: 'alert dark alert-danger', content: 'Error: ' + res.message };
        }
      }
    },
      error => {
        this.message = { class: 'alert dark alert-danger', content: 'Error: ' + error };
      });
  }

  telephoneCheck(str) {
    if (str === null || str === undefined || str.length === 0) {
      return true
    }
    var patt = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    return patt.test(str);
  }

  loadDistrictData(id: number) {
    this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
      let districts = [];
      res.data.districts.forEach((c: any) => {
        districts.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.districts = districts;
    })
  }

  onSubmit(form: NgForm) {
    let image;
    console.log('image', this.img)
    if (this.img.length == 1) {
      image = this.img[0]
    } else {
      image = ''
    }
    this.message = null;
    let objectData = {};
    let province = $('#_province option:selected').val();
    let district = $('#_district option:selected').val();
    console.log('tinh', province);
    console.log('huyen', district);
    console.log('123123', typeof (this.store.phone));

    if (this.store.name.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: 'Tên không được bỏ trống !' };
    } else if (!province) {
      this.message = { class: 'alert alert-danger', content: 'Bạn chưa chọn Tỉnh/TP !' };
    } else if (!district) {
      this.message = { class: 'alert alert-danger', content: 'Bạn chưa chọn Quận/Huyện !' };
    } else if (this.store.address.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: 'Địa chỉ không được bỏ trống !' };
    } else if (!this.telephoneCheck(this.store.phone)) {
      this.message = { class: 'alert alert-danger', content: 'Sai định dạng số điện thoại' };
    } else {
      this.processSave();
      objectData = {
        'name': this.store.name,
        'address': this.store.address,
        'provinceId': Number(province),
        'districtId': Number(district),
        'phone': this.store.phone,
        'status': this.store.status,
        'image': image
      };
      this.storeSaleService.updateStoreSale(this.id_store, objectData).subscribe(res => {
        if (res) {
          let error = res.error;
          if (error) {

            this.toastr.error('Cập nhật thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          } else {
            this.toastr.info('Cập nhật thành công !', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            this.getDetail(this.id_store);
          }
          this.backUpdate.emit({
            isBack: false
          })
          // form.reset();
        }
      }, error => {
        this.message = { class: 'alert dark alert-danger', content: error.message };
      });
    }
    this.scrollToTop();
    this.img = []
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: 'Đang thực thi...'
    };
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  ramdomID() {
    return Math.floor(Math.random() * 100);
  }

  appendImageToShow(src: any) {
    let id = this.ramdomID();
    if (this.listIndexImage.indexOf(id) !== -1) {
      id = this.ramdomID();
    }
    this.currentNumberImage++;
    // tslint:disable-next-line:prefer-const
    var listProductImage = $('#listProductImage');
    listProductImage.append(
      `<div id="` +
      'image' +
      id +
      `" style="float: left; position: relative" class="qr-item-image">
          <img id="` +
      'itemImg' +
      id +
      `" src="` +
      src +
      `" alt="" />
          <i id="` +
      'closeImg' +
      id +
      `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
          </div>`
    );
    this.listIndexImage.push(id);
    $('#' + 'closeImg' + id.toString()).click(function (res) {
      // tslint:disable-next-line:prefer-const
      var index = parseInt(
        res.currentTarget.id.toString().split('closeImg')[1]
      );
      for (let i = 0; i < that.listIndexImage.length; i++) {
        if (that.listIndexImage[i] == index) {
          $('#' + 'image' + index.toString()).remove();
          that.listIndexImage.splice(i, 1);
          that.img.splice(i, 1);
          that.currentNumberImage--;
        }
      }
    });
  }

  /*Ham them anh vao mang*/
  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    console.log('numberImages', numberImages)
    console.log('this.img', this.img.length)
    if ((numberImages + this.img.length) > 1) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.img.length >= 1) {
              console.log(1255553)
              this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              console.log(123123)
              this.img.push(image2.url);
              console.log('this.img', this.img)
              this.appendImageToShow(image2.url);
            }
          }
        });
      }
    }
  };
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store-sale/store-sale_edit.component.ts